/* eslint-disable react-hooks/exhaustive-deps */
import { useRouter } from "next/dist/client/router";
import { useEffect } from "react";

const useUnload = (isDirty: boolean, documentProcessing: boolean) => {
  const router = useRouter();

  const warningText =
    "You have unsaved changes - are you sure you wish to leave this page?";

  //util function for run in event window beforeunload
  const handleBrowserReload = (e: BeforeUnloadEvent) => {
    if (!isDirty) return;
    e.preventDefault();

    if (documentProcessing) {
      return (e.returnValue = warningText);
    }

    return (e.returnValue = warningText);
  };

  //util function for run in event window popstate
  const handlePageLeave = ({ as }) => {
    if(!isDirty) return true

    const currentPath = router.asPath;
    if (as !== currentPath) {
      if (confirm(warningText)) return true;
      else {
        window.history.pushState(null, "", currentPath);
        return false;
      }
    }
    return true;
  };

  useEffect(() => {
    window.addEventListener("beforeunload", handleBrowserReload);

    router.beforePopState(handlePageLeave);

    return () => {
      window.removeEventListener("beforeunload", handleBrowserReload);
      router.beforePopState(() => true);
    };
  }, [isDirty, documentProcessing]);
};

export default useUnload;
